import React from 'react';

interface WidgetShellProps {
  title: string;
  icon?: React.ReactNode;
  /** Optional right-side header slot (e.g. a small dropdown). */
  headerActions?: React.ReactNode;
  loading?: boolean;
  error?: Error | null;
  empty?: boolean;
  emptyText?: string;
  children?: React.ReactNode;
}

/**
 * Wraps every dashboard widget with a consistent header + loading/error/empty
 * state handling. Pass `loading | error | empty` for the standard placeholders
 * or render content directly via `children`.
 */
const WidgetShell: React.FC<WidgetShellProps> = ({
  title, icon, headerActions, loading, error, empty, emptyText = 'No data', children,
}) => (
  <div className="dashboard-widget">
    <div className="dashboard-widget-header">
      <div className="dashboard-widget-title">
        {icon}
        <span>{title}</span>
      </div>
      {headerActions && <div>{headerActions}</div>}
    </div>
    <div className="dashboard-widget-body">
      {loading ? (
        <div className="dashboard-widget-loading">Loading…</div>
      ) : error ? (
        <div className="dashboard-widget-error">{error.message || 'Failed to load.'}</div>
      ) : empty ? (
        <div className="dashboard-widget-empty">{emptyText}</div>
      ) : (
        children
      )}
    </div>
  </div>
);

export default WidgetShell;
